import { defineMessages } from "../core"

export const sidebar = defineMessages({
  en: {
    "sidebar.newConversation": "New conversation",
    "sidebar.devDummyChats": "Dev: add 3 dummy chats",
    "sidebar.searchConversations": "Search conversations",
    "sidebar.recent": "Recent",
    "sidebar.noMatches": "No matching conversations.",
    "sidebar.noConversations": "No conversations yet.",
    "sidebar.conversationActionsFor": "Conversation actions for \"{title}\"",
    "sidebar.conversationActions": "Conversation actions",
    "sidebar.moveToRegular": "Move to regular chats",
    "sidebar.moveTo": "Move to {name}",
    "sidebar.deleteConversationFor": "Delete conversation \"{title}\"",
    "sidebar.delete": "Delete",
    "sidebar.searchModeAria": "Search mode: {mode}. Click to change.",
    "sidebar.searchModeTitle": "Search mode - click to switch between Work IQ and Classic",
    "sidebar.searchMode": "Search mode",
    "sidebar.workIq": "Work IQ",
    "sidebar.classic": "Classic",
    "sidebar.workIqHint": "One question searches SharePoint, OneDrive, mail, Teams and meetings with your own permissions. Uses Copilot credits.",
    "sidebar.classicHint": "Classic SharePoint search; choose SharePoint, mail and Teams per request.",
    "sidebar.projects": "Projects",
    "sidebar.createProject": "Create project",
    "sidebar.loadingProjects": "Loading projects…",
    "sidebar.createProjectHint": "Create a project to group related chats.",
    "sidebar.newChat": "New chat",
    "sidebar.newChatIn": "New chat in {name}",
    "sidebar.projectActionsFor": "Project actions for {name}",
    "sidebar.projectActions": "Project actions",
    "sidebar.editProject": "Edit project",
    "sidebar.chatsCount": "Chats ({count})",
    "sidebar.noChatsInProject": "No conversations in this project yet.",
    "sidebar.loadingDocuments": "Loading documents…",
    "sidebar.noDocuments": "No referenced documents yet.",
    "sidebar.allHidden": "All documents are hidden.",
    "sidebar.documentsCount": "Documents ({count})",
    "sidebar.showLess": "Show less",
    "sidebar.moreCount": "+{count} more",
    "sidebar.hiddenCount": "Hidden ({count})",
    "sidebar.restoreDoc": "Restore {title}",
    "sidebar.hideDoc": "Hide {title}",
    "sidebar.restoreDocTitle": "Restore: use this document as context again",
    "sidebar.hideDocTitle": "Hide: stop using this document as context",
    "sidebar.hideFailed": "Document could not be hidden.",
    "sidebar.restoreFailed": "Document could not be restored.",
    "sidebar.detailsLoadFailed": "Project details could not be loaded.",
    "sidebar.instructionsSaveFailed": "Project created, but its instructions could not be saved. Edit the project to retry.",
    "sidebar.saveFailed": "Project could not be saved.",
    "sidebar.deleteFailed": "Project could not be deleted.",
    "sidebar.dialogCreate": "Create project",
    "sidebar.dialogEdit": "Edit project",
    "sidebar.privateNote": "Projects and their conversations are private to you.",
    "sidebar.close": "Close",
    "sidebar.projectName": "Project name",
    "sidebar.description": "Description",
    "sidebar.optional": "(optional)",
    "sidebar.instructions": "Instructions",
    "sidebar.instructionsPlaceholder": "Add project-specific context and guidance for your chats.",
    "sidebar.deleteProject": "Delete project",
    "sidebar.cancel": "Cancel",
    "sidebar.saving": "Saving…",
    "sidebar.saveProject": "Save project",
    "sidebar.deleteTitle": "Delete “{name}”?",
    "sidebar.deleteChoose": "Choose what happens to its conversations.",
    "sidebar.deleteMove": "Move conversations to regular chats",
    "sidebar.deleteAll": "Delete all project conversations",
    "sidebar.deleteConfirm": "I understand this permanently deletes all conversations in this project.",
    "sidebar.deleting": "Deleting…",
    "sidebar.deleteProjectAndChats": "Delete project and chats",
  },
  de: {
    "sidebar.newConversation": "Neue Unterhaltung",
    "sidebar.devDummyChats": "Dev: 3 Dummy-Chats hinzufügen",
    "sidebar.searchConversations": "Unterhaltungen durchsuchen",
    "sidebar.recent": "Zuletzt",
    "sidebar.noMatches": "Keine passenden Unterhaltungen.",
    "sidebar.noConversations": "Noch keine Unterhaltungen.",
    "sidebar.conversationActionsFor": "Aktionen für Unterhaltung \"{title}\"",
    "sidebar.conversationActions": "Unterhaltungsaktionen",
    "sidebar.moveToRegular": "In normale Chats verschieben",
    "sidebar.moveTo": "Nach {name} verschieben",
    "sidebar.deleteConversationFor": "Unterhaltung \"{title}\" löschen",
    "sidebar.delete": "Löschen",
    "sidebar.searchModeAria": "Suchmodus: {mode}. Klicken zum Ändern.",
    "sidebar.searchModeTitle": "Suchmodus – klicken, um zwischen Work IQ und Classic zu wechseln",
    "sidebar.searchMode": "Suchmodus",
    "sidebar.workIq": "Work IQ",
    "sidebar.classic": "Classic",
    "sidebar.workIqHint": "Eine Frage durchsucht SharePoint, OneDrive, E-Mails, Teams und Meetings mit deinen eigenen Berechtigungen. Verbraucht Copilot-Credits.",
    "sidebar.classicHint": "Classic-SharePoint-Suche; SharePoint, E-Mail und Teams pro Anfrage auswählen.",
    "sidebar.projects": "Projekte",
    "sidebar.createProject": "Projekt erstellen",
    "sidebar.loadingProjects": "Projekte werden geladen…",
    "sidebar.createProjectHint": "Erstelle ein Projekt, um zusammengehörige Chats zu bündeln.",
    "sidebar.newChat": "Neuer Chat",
    "sidebar.newChatIn": "Neuer Chat in {name}",
    "sidebar.projectActionsFor": "Projektaktionen für {name}",
    "sidebar.projectActions": "Projektaktionen",
    "sidebar.editProject": "Projekt bearbeiten",
    "sidebar.chatsCount": "Chats ({count})",
    "sidebar.noChatsInProject": "Noch keine Unterhaltungen in diesem Projekt.",
    "sidebar.loadingDocuments": "Dokumente werden geladen…",
    "sidebar.noDocuments": "Noch keine referenzierten Dokumente.",
    "sidebar.allHidden": "Alle Dokumente sind ausgeblendet.",
    "sidebar.documentsCount": "Dokumente ({count})",
    "sidebar.showLess": "Weniger anzeigen",
    "sidebar.moreCount": "+{count} weitere",
    "sidebar.hiddenCount": "Ausgeblendet ({count})",
    "sidebar.restoreDoc": "{title} wiederherstellen",
    "sidebar.hideDoc": "{title} ausblenden",
    "sidebar.restoreDocTitle": "Wiederherstellen: Dokument wieder als Kontext verwenden",
    "sidebar.hideDocTitle": "Ausblenden: Dokument nicht mehr als Kontext verwenden",
    "sidebar.hideFailed": "Das Dokument konnte nicht ausgeblendet werden.",
    "sidebar.restoreFailed": "Das Dokument konnte nicht wiederhergestellt werden.",
    "sidebar.detailsLoadFailed": "Die Projektdetails konnten nicht geladen werden.",
    "sidebar.instructionsSaveFailed": "Projekt erstellt, aber die Anweisungen konnten nicht gespeichert werden. Bearbeite das Projekt, um es erneut zu versuchen.",
    "sidebar.saveFailed": "Das Projekt konnte nicht gespeichert werden.",
    "sidebar.deleteFailed": "Das Projekt konnte nicht gelöscht werden.",
    "sidebar.dialogCreate": "Projekt erstellen",
    "sidebar.dialogEdit": "Projekt bearbeiten",
    "sidebar.privateNote": "Projekte und ihre Unterhaltungen sind nur für dich sichtbar.",
    "sidebar.close": "Schließen",
    "sidebar.projectName": "Projektname",
    "sidebar.description": "Beschreibung",
    "sidebar.optional": "(optional)",
    "sidebar.instructions": "Anweisungen",
    "sidebar.instructionsPlaceholder": "Ergänze projektspezifischen Kontext und Hinweise für deine Chats.",
    "sidebar.deleteProject": "Projekt löschen",
    "sidebar.cancel": "Abbrechen",
    "sidebar.saving": "Wird gespeichert…",
    "sidebar.saveProject": "Projekt speichern",
    "sidebar.deleteTitle": "„{name}“ löschen?",
    "sidebar.deleteChoose": "Wähle, was mit den Unterhaltungen geschehen soll.",
    "sidebar.deleteMove": "Unterhaltungen in normale Chats verschieben",
    "sidebar.deleteAll": "Alle Projektunterhaltungen löschen",
    "sidebar.deleteConfirm": "Mir ist bewusst, dass dadurch alle Unterhaltungen in diesem Projekt endgültig gelöscht werden.",
    "sidebar.deleting": "Wird gelöscht…",
    "sidebar.deleteProjectAndChats": "Projekt und Chats löschen",
  },
})
